export const toast = {
    success: (_msg) => undefined,
    error: (_msg) => undefined,
    info: (_msg) => undefined,
};
//# sourceMappingURL=toast.js.map